import { useEffect, useState } from 'react';
import apiClient from '../utils/axios';
import { Plus, Play, Pause, Trash2, Search, Filter } from 'lucide-react';
import MultiSelect from '../components/MultiSelect';

// US States
const US_STATES = [
  { value: 'Alabama', label: 'Alabama' },
  { value: 'Alaska', label: 'Alaska' },
  { value: 'Arizona', label: 'Arizona' },
  { value: 'Arkansas', label: 'Arkansas' },
  { value: 'California', label: 'California' },
  { value: 'Colorado', label: 'Colorado' },
  { value: 'Connecticut', label: 'Connecticut' },
  { value: 'Delaware', label: 'Delaware' },
  { value: 'Florida', label: 'Florida' },
  { value: 'Georgia', label: 'Georgia' },
  { value: 'Hawaii', label: 'Hawaii' },
  { value: 'Idaho', label: 'Idaho' },
  { value: 'Illinois', label: 'Illinois' },
  { value: 'Indiana', label: 'Indiana' },
  { value: 'Iowa', label: 'Iowa' },
  { value: 'Kansas', label: 'Kansas' },
  { value: 'Kentucky', label: 'Kentucky' },
  { value: 'Louisiana', label: 'Louisiana' },
  { value: 'Maine', label: 'Maine' },
  { value: 'Maryland', label: 'Maryland' },
  { value: 'Massachusetts', label: 'Massachusetts' },
  { value: 'Michigan', label: 'Michigan' },
  { value: 'Minnesota', label: 'Minnesota' },
  { value: 'Mississippi', label: 'Mississippi' },
  { value: 'Missouri', label: 'Missouri' },
  { value: 'Montana', label: 'Montana' },
  { value: 'Nebraska', label: 'Nebraska' },
  { value: 'Nevada', label: 'Nevada' },
  { value: 'New Hampshire', label: 'New Hampshire' },
  { value: 'New Jersey', label: 'New Jersey' },
  { value: 'New Mexico', label: 'New Mexico' },
  { value: 'New York', label: 'New York' },
  { value: 'North Carolina', label: 'North Carolina' },
  { value: 'North Dakota', label: 'North Dakota' },
  { value: 'Ohio', label: 'Ohio' },
  { value: 'Oklahoma', label: 'Oklahoma' },
  { value: 'Oregon', label: 'Oregon' },
  { value: 'Pennsylvania', label: 'Pennsylvania' },
  { value: 'Rhode Island', label: 'Rhode Island' },
  { value: 'South Carolina', label: 'South Carolina' },
  { value: 'South Dakota', label: 'South Dakota' },
  { value: 'Tennessee', label: 'Tennessee' },
  { value: 'Texas', label: 'Texas' },
  { value: 'Utah', label: 'Utah' },
  { value: 'Vermont', label: 'Vermont' },
  { value: 'Virginia', label: 'Virginia' },
  { value: 'Washington', label: 'Washington' },
  { value: 'West Virginia', label: 'West Virginia' },
  { value: 'Wisconsin', label: 'Wisconsin' },
  { value: 'Wyoming', label: 'Wyoming' },
  { value: 'District of Columbia', label: 'District of Columbia' }
];

// Industries
const INDUSTRIES = [
  { value: 'Healthcare', label: 'Healthcare' },
  { value: 'Manufacturing', label: 'Manufacturing' },
  { value: 'Technology', label: 'Technology' },
  { value: 'Financial Services', label: 'Financial Services' },
  { value: 'Real Estate', label: 'Real Estate' },
  { value: 'Retail', label: 'Retail' },
  { value: 'Transportation', label: 'Transportation & Logistics' },
  { value: 'Education', label: 'Education' },
  { value: 'Energy', label: 'Energy & Utilities' },
  { value: 'Construction', label: 'Construction' },
  { value: 'Hospitality', label: 'Hospitality & Tourism' },
  { value: 'Media', label: 'Media & Entertainment' },
  { value: 'Telecommunications', label: 'Telecommunications' },
  { value: 'Agriculture', label: 'Agriculture' },
  { value: 'Pharmaceuticals', label: 'Pharmaceuticals' },
  { value: 'Automotive', label: 'Automotive' },
  { value: 'Aerospace', label: 'Aerospace & Defense' },
  { value: 'Food & Beverage', label: 'Food & Beverage' },
  { value: 'Legal Services', label: 'Legal Services' },
  { value: 'Consulting', label: 'Consulting' }
];

// Job Titles
const JOB_TITLES = [
  { value: 'CEO', label: 'CEO (Chief Executive Officer)' },
  { value: 'CTO', label: 'CTO (Chief Technology Officer)' },
  { value: 'CFO', label: 'CFO (Chief Financial Officer)' },
  { value: 'CMO', label: 'CMO (Chief Marketing Officer)' },
  { value: 'COO', label: 'COO (Chief Operating Officer)' },
  { value: 'VP Sales', label: 'VP of Sales' },
  { value: 'VP Marketing', label: 'VP of Marketing' },
  { value: 'VP Engineering', label: 'VP of Engineering' },
  { value: 'Director', label: 'Director' },
  { value: 'Manager', label: 'Manager' },
  { value: 'Owner', label: 'Owner' },
  { value: 'Founder', label: 'Founder' },
  { value: 'President', label: 'President' },
  { value: 'Head of Sales', label: 'Head of Sales' },
  { value: 'Head of Marketing', label: 'Head of Marketing' },
  { value: 'Sales Manager', label: 'Sales Manager' },
  { value: 'Marketing Manager', label: 'Marketing Manager' },
  { value: 'Business Development', label: 'Business Development' },
  { value: 'Procurement', label: 'Procurement' },
  { value: 'Purchasing', label: 'Purchasing' }
];

// Company Size Ranges
const COMPANY_SIZES = [
  { value: 'all', label: 'All Sizes', min: 0, max: 100000 },
  { value: '1-10', label: '1-10 employees', min: 1, max: 10 },
  { value: '11-50', label: '11-50 employees', min: 11, max: 50 },
  { value: '51-200', label: '51-200 employees', min: 51, max: 200 },
  { value: '201-500', label: '201-500 employees', min: 201, max: 500 },
  { value: '501-1000', label: '501-1,000 employees', min: 501, max: 1000 },
  { value: '1001-5000', label: '1,001-5,000 employees', min: 1001, max: 5000 },
  { value: '5001-10000', label: '5,001-10,000 employees', min: 5001, max: 10000 },
  { value: '10000+', label: '10,000+ employees', min: 10000, max: 100000 }
];

export default function ContactDiscovery() {
  const [discoveries, setDiscoveries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    industries: [],
    jobTitles: [],
    companySize: { min: 0, max: 10000 },
    companySizeRange: 'all',
    locations: [],
    monthlyBudgetLimit: '',
    processingMode: 'optimized'
  });

  useEffect(() => {
    fetchDiscoveries();
  }, []);

  const fetchDiscoveries = async () => {
    try {
      const response = await apiClient.get('/contact-discovery');
      setDiscoveries(response.data.discoveries || []);
    } catch (error) {
      console.error('Error fetching discoveries:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleCreate = async (e) => {
    e.preventDefault();
    try {
      // Handle "All US States" option
      let locations = formData.locations;
      if (locations.includes('__ALL_US__')) {
        locations = US_STATES.map(s => s.value);
      }
      
      // Handle company size selection
      let companySize = formData.companySize;
      if (formData.companySizeRange && formData.companySizeRange !== 'all') {
        const sizeOption = COMPANY_SIZES.find(s => s.value === formData.companySizeRange);
        if (sizeOption) {
          companySize = { min: sizeOption.min, max: sizeOption.max };
        }
      }
      
      const searchCriteria = {
        industries: formData.industries,
        jobTitles: formData.jobTitles,
        companySize: companySize,
        locations: locations
      };

      await apiClient.post('/contact-discovery', {
        name: formData.name,
        description: formData.description,
        searchCriteria,
        monthlyBudgetLimit: formData.monthlyBudgetLimit ? parseFloat(formData.monthlyBudgetLimit) : null,
        processingMode: formData.processingMode
      });

      setShowForm(false);
      setFormData({
        name: '',
        description: '',
        industries: [],
        jobTitles: [],
        companySize: { min: 0, max: 10000 },
        companySizeRange: 'all',
        locations: [],
        monthlyBudgetLimit: '',
        processingMode: 'optimized'
      });
      fetchDiscoveries();
    } catch (error) {
      console.error('Error creating discovery:', error);
      alert('Error creating discovery campaign: ' + (error.response?.data?.message || error.message));
    }
  };

  const handleStart = async (id) => {
    try {
      await apiClient.post(`/contact-discovery/${id}/start`);
      fetchDiscoveries();
    } catch (error) {
      console.error('Error starting discovery:', error);
      alert('Error starting discovery: ' + (error.response?.data?.message || error.message));
    }
  };

  const handlePause = async (id) => {
    try {
      await apiClient.post(`/contact-discovery/${id}/pause`);
      fetchDiscoveries();
    } catch (error) {
      console.error('Error pausing discovery:', error);
      alert('Error pausing discovery: ' + (error.response?.data?.message || error.message));
    }
  };

  const handleDelete = async (id) => {
    if (!confirm('Are you sure you want to delete this discovery campaign?')) {
      return;
    }

    try {
      await apiClient.delete(`/contact-discovery/${id}`);
      fetchDiscoveries();
    } catch (error) {
      console.error('Error deleting discovery:', error);
      alert('Error deleting discovery: ' + (error.response?.data?.message || error.message));
    }
  };

  if (loading) {
    return (
      <div className="p-8 text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-600 mx-auto"></div>
        <p className="mt-4 text-gray-600">Loading discovery campaigns...</p>
      </div>
    );
  }

  return (
    <div className="p-6">
      <div className="flex justify-between items-center mb-8">
        <div>
          <h1 className="text-3xl font-bold text-gray-900">Contact Discovery</h1>
          <p className="mt-2 text-gray-600">Discover and enrich contacts from public sources</p>
        </div>
        <button
          onClick={() => setShowForm(!showForm)}
          className="bg-purple-600 text-white px-4 py-2 rounded-lg hover:bg-purple-700 flex items-center gap-2"
        >
          <Plus size={20} />
          New Discovery Campaign
        </button>
      </div>

      {showForm && (
        <div className="bg-white rounded-lg shadow p-6 mb-6">
          <h2 className="text-xl font-semibold mb-4">Create Discovery Campaign</h2>
          <form onSubmit={handleCreate} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Name</label>
              <input
                type="text"
                value={formData.name}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                className="w-full border border-gray-300 rounded-lg px-3 py-2"
                required
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Description</label>
              <textarea
                value={formData.description}
                onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                className="w-full border border-gray-300 rounded-lg px-3 py-2"
                rows={3}
              />
            </div>
            <div className="border-t pt-4 mt-4">
              <h3 className="text-lg font-semibold text-gray-900 mb-4">Search Criteria</h3>
              
              <div className="grid grid-cols-2 gap-4 mb-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Industries
                  </label>
                  <MultiSelect
                    options={INDUSTRIES}
                    selected={formData.industries}
                    onChange={(industries) => setFormData({ ...formData, industries })}
                    placeholder="Select industries..."
                    showAllOption={true}
                    allOptionLabel="All Industries"
                  />
                  <p className="text-xs text-gray-500 mt-1">Select one or more industries to target</p>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    US Locations
                  </label>
                  <MultiSelect
                    options={[
                      { value: '__ALL_US__', label: 'Everywhere in US (All States)' },
                      ...US_STATES
                    ]}
                    selected={formData.locations}
                    onChange={(locations) => setFormData({ ...formData, locations })}
                    placeholder="Select locations..."
                    showAllOption={false}
                  />
                  <p className="text-xs text-gray-500 mt-1">Select US states to target (or select "Everywhere in US")</p>
                </div>
              </div>

              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Job Titles <span className="text-gray-500 text-xs">(optional)</span>
                </label>
                <MultiSelect
                  options={JOB_TITLES}
                  selected={formData.jobTitles}
                  onChange={(jobTitles) => setFormData({ ...formData, jobTitles })}
                  placeholder="Select job titles (optional)..."
                  showAllOption={true}
                  allOptionLabel="All Job Titles"
                />
                <p className="text-xs text-gray-500 mt-1">Optional: Target specific job titles</p>
              </div>

              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-1">Company Size</label>
                <select
                  value={formData.companySizeRange || 'all'}
                  onChange={(e) => {
                    const range = e.target.value;
                    setFormData({ 
                      ...formData, 
                      companySizeRange: range,
                      companySize: range === 'all' 
                        ? { min: 0, max: 100000 }
                        : (() => {
                            const sizeOption = COMPANY_SIZES.find(s => s.value === range);
                            return sizeOption ? { min: sizeOption.min, max: sizeOption.max } : { min: 0, max: 100000 };
                          })()
                    });
                  }}
                  className="w-full border border-gray-300 rounded-lg px-3 py-2"
                >
                  {COMPANY_SIZES.map(size => (
                    <option key={size.value} value={size.value}>{size.label}</option>
                  ))}
                </select>
                <p className="text-xs text-gray-500 mt-1">Select company size range by number of employees</p>
              </div>
            </div>

            <div className="border-t pt-4 mt-4">
              <h3 className="text-lg font-semibold text-gray-900 mb-4">Budget & Processing</h3>
              
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Monthly Budget Limit ($)</label>
                  <input
                    type="number"
                    value={formData.monthlyBudgetLimit}
                    onChange={(e) => setFormData({ ...formData, monthlyBudgetLimit: e.target.value })}
                    className="w-full border border-gray-300 rounded-lg px-3 py-2"
                    min="0"
                    step="0.01"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Processing Mode</label>
                  <select
                    value={formData.processingMode}
                    onChange={(e) => setFormData({ ...formData, processingMode: e.target.value })}
                    className="w-full border border-gray-300 rounded-lg px-3 py-2"
                  >
                    <option value="full_speed">Full Speed</option>
                    <option value="optimized">Optimized</option>
                    <option value="conservation">Conservation</option>
                    <option value="emergency">Emergency</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="flex gap-2">
              <button
                type="submit"
                className="bg-purple-600 text-white px-4 py-2 rounded-lg hover:bg-purple-700"
              >
                Create Campaign
              </button>
              <button
                type="button"
                onClick={() => setShowForm(false)}
                className="bg-gray-200 text-gray-700 px-4 py-2 rounded-lg hover:bg-gray-300"
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      )}

      <div className="bg-white rounded-lg shadow overflow-hidden">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Name</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Status</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Companies</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Contacts</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Budget</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Actions</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {discoveries.map((discovery) => (
              <tr key={discovery.id}>
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="font-medium text-gray-900">{discovery.name}</div>
                  <div className="text-sm text-gray-500">{discovery.description}</div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <span className={`px-2 py-1 text-xs rounded-full ${
                    discovery.status === 'active' ? 'bg-green-100 text-green-800' :
                    discovery.status === 'paused' ? 'bg-yellow-100 text-yellow-800' :
                    discovery.status === 'completed' ? 'bg-blue-100 text-blue-800' :
                    'bg-gray-100 text-gray-800'
                  }`}>
                    {discovery.status}
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                  {discovery.companies_count || 0}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                  {discovery.contacts_count || 0}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                  {discovery.monthly_budget_limit ? (
                    <>
                      ${parseFloat(discovery.current_month_spend || 0).toFixed(2)} / ${parseFloat(discovery.monthly_budget_limit).toFixed(2)}
                    </>
                  ) : (
                    'Unlimited'
                  )}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                  <div className="flex gap-2">
                    {discovery.status === 'draft' || discovery.status === 'paused' ? (
                      <button
                        onClick={() => handleStart(discovery.id)}
                        className="text-green-600 hover:text-green-900"
                        title="Start"
                      >
                        <Play size={16} />
                      </button>
                    ) : discovery.status === 'active' ? (
                      <button
                        onClick={() => handlePause(discovery.id)}
                        className="text-yellow-600 hover:text-yellow-900"
                        title="Pause"
                      >
                        <Pause size={16} />
                      </button>
                    ) : null}
                    <button
                      onClick={() => handleDelete(discovery.id)}
                      className="text-red-600 hover:text-red-900"
                      title="Delete"
                    >
                      <Trash2 size={16} />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {discoveries.length === 0 && (
          <div className="text-center py-12 text-gray-500">
            No discovery campaigns found. Create one to get started.
          </div>
        )}
      </div>
    </div>
  );
}

